export default __webpack_public_path__ + "static/media/curso-generico.d53613b9.png";